export * from "./mapImage";
export * from "./mapTreatmentInfoItems";
